import {Component} from 'lowkey-component';

import {createTrainingState} from '@services/TrainingState';

export class TrainingItem extends Component {
  private state = createTrainingState();

  didMount() {
    this.on('click', this.onClick);
  }

  onClick = (e: Event) => {
    if (e.currentTarget) {
      const target = e.currentTarget as HTMLAnchorElement;
      const id = target.dataset['id'] || '';
      this.state.appendTrainingModal({id, isOpen: false});
    }
  };

  didUnmount() {}
}
